import React from "react";

import { useTranslation } from "react-i18next";

import { APP_TOOLTIP_ID } from "@/src/constants/tooltip";

import PaymentIcon from "./PaymentIcon";
import { getPaymentLabel, isPaymentKind } from "./paymentIcons";

import type { JSX } from "react";

interface PaymentCellProps {
  payment: string;
  retailerName: string | undefined;
}

function PaymentCell({ payment, retailerName }: PaymentCellProps): JSX.Element {
  const { t } = useTranslation("editor-analytics");

  if (!isPaymentKind(payment)) {
    return <React.Fragment>{payment}</React.Fragment>;
  }

  const label = getPaymentLabel(payment, retailerName, t);
  return (
    <span
      className="inline-flex align-middle"
      data-tooltip-content={label}
      data-tooltip-id={APP_TOOLTIP_ID}
    >
      <PaymentIcon kind={payment} />
      <span className="sr-only">{label}</span>
    </span>
  );
}

export default PaymentCell;
